// config
import config from '/config/default.json';
import prodConfig from '/config/production.json'

const getURL = (url, params) => {
    
    let result = '';
    if (process.env.NODE_ENV === 'production') {
        result = `${prodConfig.app.apiConnect}${url}`;
    }
    else{
        result = `${config.app.apiConnect}${url}`;
    }
    

    if (params) {
        result += `?${new URLSearchParams(params)}`;
    }

    return result;
}

export default getURL;